// @flow
import * as React from "react"
import classnames from "classnames"

import spFieldWrapper from "../../../../app/scripts/tools/spFieldWrapper"
import Translate from "../../../../app/scripts/components/Translate"
import type { SpFieldFunc } from "../../../../app/scripts/tools/spFieldWrapper"

type Props = {
  bordered?: boolean,
  checked?: boolean,
  classList?: string, // confusing string not array
  error?: string,
  middle?: boolean,
  showErrorNote?: boolean,
  checked?: boolean,
  touched: boolean,
  // eslint-disable-next-line flowtype/no-weak-types
  valueLink?: Object,
  // eslint-disable-next-line flowtype/no-weak-types
  spFieldFunc: SpFieldFunc,
  // eslint-disable-next-line flowtype/no-weak-types
  onChange: Function,
  children: React.Node,
}

const extractAriaProps = (props: Props) => ({
  // $FlowFixMe
  "aria-labelledby": props["aria-labelledby"],
  // $FlowFixMe
  id: props.checkBoxID,
})

const CheckBoxField = (props: Props) => {
  const {
    bordered = true,
    classList,
    error,
    middle,
    showErrorNote,
    touched,
    valueLink,
    spFieldFunc,
  } = props
  const hasError = touched && error

  return (
    <div
      className={classnames(
        "CheckBoxField spField",
        spFieldFunc.getClasses(),
        { _bordered: bordered, _error: hasError, _middle: middle },
        classList,
      )}
    >
      <label className="CheckBoxField-wrapper">
        <div className="CheckBoxField-checkbox">
          <input
            className="spCheckbox"
            type="checkbox"
            onChange={props.onChange}
            // Initially can be undefined => react uncontrolled element warning
            checked={props.checked || false}
            {...extractAriaProps(props)}
          />
        </div>
        <div className="CheckBoxField-label" data-test="CheckBoxField-label">
          <span>{props.children}</span>
        </div>
      </label>

      {valueLink
        ? spFieldFunc.renderError()
        : hasError &&
          showErrorNote && (
            <div className="spField-error">
              <span className="spField-note spTypo-note">
                <Translate tKey={error} />
              </span>
            </div>
          )}
    </div>
  )
}

export default spFieldWrapper(CheckBoxField)
